/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  rendererIconByName,
  ROW_DELETED_CLASS,
  truthyCellRenderer,
} from '@gh/common-internal-shared';
import { LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import { CustomFieldListItem } from '../../resources/custom-field.model';

@Injectable()
export class CustomFieldListTabGridDefinition extends LayoutBasedGridDefinition {
  columnDefs = {
    required: {
      cellRenderer: truthyCellRenderer(rendererIconByName('done')),
    },
  };
  options = {
    getRowId: (params) => String(params.data.customFieldId),
    rowClassRules: {
      [ROW_DELETED_CLASS]: ({ data }: { data: CustomFieldListItem }) => data.active !== true,
    },
  };
}
